import * as React from "react";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import styled from "styled-components";
import Spinner from "components/common/Spinner";
import { widgetDefinition } from "views/logic/Widgets";
import { IconButton } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const StyledIconButton = styled(IconButton)`
  span {
    position: relative;
    left: -1px;
  }
`;
const WidgetHorizontalStretch = ({ onStretch, position, widgetId, widgetType }) => {
  const { t } = useTranslation("widgets");
  const sendTelemetry = useSendTelemetry("search-widget");
  const onClick = useCallback(() => {
    const { col, row, height, width: width2 } = position;
    const { defaultWidth } = widgetDefinition(widgetType);
    onStretch({
      id: widgetId,
      col,
      row,
      height,
      width: width2 === Infinity ? defaultWidth : Infinity
    });
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.SEARCH_WIDGET_HORIZONTAL_STRETCH, {
      app_action_value: "widget-stretch-button"
    });
  }, [onStretch, position, sendTelemetry, widgetId, widgetType]);
  if (!position) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { width } = position;
  const stretched = width === Infinity;
  const icon = stretched ? "compress" : "expand";
  const title = stretched ? t("widget_actions.compress_width") : t("widget_actions.stretch_width");
  return /* @__PURE__ */ React.createElement(StyledIconButton, { onClick, name: icon, title, rotation: 90 });
};
export default WidgetHorizontalStretch;
